import {useJobContext} from 'contexts/JobContext';
import React from 'react';
import {formatPrice} from 'shared/helpers';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';
import {VariationCostMoreInfo} from 'shared/components/Header/VariationCostMoreInfo';
import {PartialJob} from 'shared/types/PartialJob';

export const VariationCost = () => {
    const {job} = useJobContext() as PartialJob;

    return job.variationCost ? (
        <li>
            <span style={{display: 'flex'}}>
                <strong>Total Variation Cost:</strong>
                {job.rooms ? (
                    <MoreInfoStatic
                        editbuttonVisible={false}
                        hoverText="Total Variation Costs"
                        dialogClassName="modal-md"
                        info={<VariationCostMoreInfo />}
                    />
                ) : null}
            </span>
            <span>
                <strong>{formatPrice(job.totalVariationCost, job)}</strong>
            </span>
        </li>
    ) : job?.totalVariationCost > 0 ? (
        <li>
            <span style={{display: 'flex'}}>
                <strong>Total Variation Cost:</strong>
                {job.rooms ? (
                    <MoreInfoStatic
                        editbuttonVisible={false}
                        hoverText="Total Variation Costs"
                        dialogClassName="modal-md"
                        info={<VariationCostMoreInfo />}
                    />
                ) : null}
            </span>
            <span>
                <strong>{formatPrice(job.totalVariationCost, job)}</strong>
            </span>
        </li>
    ) : null;
};
